export default {
  404: 'No se encontró al usuario.',
  405: 'Contraseña no válida',
  407: 'No es posible impersonar a un empleado inactivo.',
  410: 'El empleado no existe.',
  446: 'Este empleado no tiene contratos activos.',
};
